var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.59996 0.200012C3.99244 0.200012 3.49996 0.692499 3.49996 1.30001V2.40001H2.39995C1.18493 2.40001 0.199951 3.38499 0.199951 4.60001V15.6C0.199951 16.815 1.18493 17.8 2.39995 17.8H15.6C16.815 17.8 17.8 16.815 17.8 15.6V4.60001C17.8 3.38499 16.815 2.40001 15.6 2.40001H14.5V1.30001C14.5 0.692499 14.0075 0.200012 13.4 0.200012C12.7925 0.200012 12.3 0.692499 12.3 1.30001V2.40001H5.69996V1.30001C5.69996 0.692499 5.20747 0.200012 4.59996 0.200012ZM4.59996 5.70001C3.99244 5.70001 3.49996 6.1925 3.49996 6.80001C3.49996 7.40752 3.99244 7.90001 4.59996 7.90001H13.4C14.0075 7.90001 14.5 7.40752 14.5 6.80001C14.5 6.1925 14.0075 5.70001 13.4 5.70001H4.59996Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.4c84951c3e3e10a34cccb19ee0a9644c.svg";
export { ForwardRef as ReactComponent };